import http from '../utils/http';
import userFlags from './user-flags';
import visitorFlags from './visitor-flags';

const initRequests = (apiUrl, authToken) => {
  http.setDefaultApiUrl(apiUrl);

  if (authToken) {
    http.setDefaultAuthHeader(authToken);
  }

  return {
    userFlags,
    visitorFlags,
  };
};

export default initRequests;
